#@import moment
#@import moment-timezone
#@import BookingComponents
#@import GliveBooking
#@import GliveBooking.Models.Booker
#@import GliveBooking.Views.Booker
#@export BookingV2.gliveDealBookerInit

BookingV2.gliveDealBookerInit = (isTouchRequest, payload, done = ->) ->
  return done() unless payload

  GliveBooking.bhw = 'GliveBookingDealBooker'
  {calendar, deal, places, timezoneData, el, error, overlapWith, metasSettings, optionId, partySize, datetime, phoneNumber} = payload

  moment.tz.add timezoneData if timezoneData?

  gliveAvailabilityHash = payload["gliveAvailabilityHash"]

  model = new GliveBooking.Models.Booker
    bookAndBuy: true
    calendar: calendar
    deal: deal
    gliveAvailabilityHash: gliveAvailabilityHash
    isTouchRequest: isTouchRequest

  view = new GliveBooking.Views.Booker
    attributes: {'data-bhw': 'GliveBookingDealBooker'}
    el: el or '#deal-booker'
    overlapWith: overlapWith or '#purchase-cluster .buy, #purchase-cluster .buy-for-friend-module, #purchase-cluster .limited-time, #purchase-cluster .deal-status, #purchase-cluster .deal-discount, #purchase-cluster .gift-card'
    model: model
    templateName: 'deal_booker'
    metasSettings: metasSettings

  view.on 'buy', (option, reservation) ->
    buyUrl = option.get('buyUrl')

    window.location = buyUrl

  $ ->
    view.setOpenAndLocked() unless $('#purchase-cluster .buy').length
    view.render()

    done()
